import { ActionTypes } from '../constants/actionTypes.js';

export const setUserDetails = (userInfo) => ({
    type: ActionTypes.SET_AUTHORIZATION_USERINFO,
    payload: userInfo
   });

export const setNavigationDrawerState = () => ({
    type: ActionTypes.SET_NAVIGATION_DRAWER_STATE
});

export const setLogoutChecked = (checked) => ({
    type: ActionTypes.SET_PORTAL_LOGOUT,
    payload: checked
});

export const setUserRole =(payload) => ({
    type: ActionTypes.SET_USER_ROLES,
    payload: payload
});

export const setUserPermission =(payload) => ({
    type: ActionTypes.SET_USER_PERMISSIONS,
    payload: payload
});
  